import React, { VFC } from 'react';
import { Route } from 'react-router-dom';

import {
  PASSWORD_RESET_NEW,
  PASSWORD_RESET_NEW_COMPLETE,
  PASSWORD_RESET_EDIT,
  PASSWORD_RESET_EDIT_COMPLETE,
  determineAppViewPath,
} from '../../constants/routing';
import { PasswordResetNewPage } from './New/Loadable';
import { PasswordResetNewCompletePage } from './NewComplete/Loadable';
import { PasswordResetEditPage } from './Edit/Loadable';
import { PasswordResetEditCompletePage } from './EditComplete/Loadable';

const PasswordResetRoute: VFC = (props) => {
  return (
    <>
      <Route
        exact
        path={determineAppViewPath(PASSWORD_RESET_NEW)}
        component={PasswordResetNewPage}
      />
      <Route
        exact
        path={determineAppViewPath(PASSWORD_RESET_NEW_COMPLETE)}
        component={PasswordResetNewCompletePage}
      />
      <Route
        exact
        path={determineAppViewPath(PASSWORD_RESET_EDIT)}
        component={PasswordResetEditPage}
      />
      <Route
        exact
        path={determineAppViewPath(PASSWORD_RESET_EDIT_COMPLETE)}
        component={PasswordResetEditCompletePage}
      />
    </>
  );
};

export default PasswordResetRoute;
